/*
 * Author: Housefolios
 * Create Time: 2021-09-16 13:21:50
 * @ Modified by: David Helmick
 * @ Modified time: 2025-10-23 14:30:39
 * Description: Bulk delete comps button and dialog - Refactored to use generic DeleteConfirmationDialog
 */

import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconButton, Tooltip } from '@mui/material'
import { useMutation } from '@apollo/client/react'
import DeleteConfirmationDialog from '@/housefolios-components/Common/DeleteConfirmationDialog'
import { useDeleteConfirmation } from '@/housefolios-components/Common/DeleteConfirmationDialog/useDeleteConfirmation'
import { DELETE_COMP_MULTI } from '@/housefolios-components/PropertyContainer/mutations'
import {
  GET_COMPPROPERTIES,
  GET_PROPERTY,
} from '@/housefolios-components/PropertyContainer/queries'

function DeleteCompsComponent(props) {
  const { bulkActionsNotifications } = props

  const [deleteCompProperties] = useMutation(DELETE_COMP_MULTI)

  const { open, loading, openDialog, closeDialog, handleDelete } =
    useDeleteConfirmation({
      onDelete: async () => {
        await deleteCompProperties({
          awaitRefetchQueries: true,
          variables: { ids: props.selected },
          refetchQueries: [
            {
              query: GET_PROPERTY,
              variables: { id: props.propertyId },
            },
            {
              query: GET_COMPPROPERTIES,
              variables: { propertyId: props.propertyId },
            },
          ],
        })

        if (props.setSelected) props.setSelected([])
      },
      successMessage: 'Selected Comps Deleted',
      errorMessage: 'Failed to Delete Selected Comps',
    })

  return (
    <>
      {bulkActionsNotifications && (
        <Tooltip title="Bulk Delete">
          <IconButton onClick={openDialog} size="large">
            <FontAwesomeIcon
              icon={['far', 'trash-can']}
              style={{ color: 'white' }}
            />
          </IconButton>
        </Tooltip>
      )}

      <DeleteConfirmationDialog
        open={open}
        onClose={closeDialog}
        onConfirm={handleDelete}
        title="Delete Comps?"
        confirmationText="Delete these comps. This action can't be undone"
        successMessage="Selected Comps Deleted"
        errorMessage="Failed to Delete Selected Comps"
        loading={loading}
        loadingMessage="Deleting Comp"
        showSharedWarning={false}
        sharedWarningText=""
        icon="trash-can"
        iconStyle="far"
        cancelButtonText="Cancel"
        deleteButtonText="Delete"
        requireConfirmation={true}
        children={null}
      />
    </>
  )
}

export default DeleteCompsComponent
